import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[#1a4d5c]" data-id="element-124">
      {/* Background Pattern/Overlay */}
      <div className="absolute inset-0 z-0 opacity-10" data-id="element-125">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center mix-blend-overlay" data-id="element-126"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a4d5c] to-transparent" data-id="element-127"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-128">
        <div className="max-w-3xl" data-id="element-129">
          <div className="inline-block px-3 py-1 mb-6 border border-[#d4a017] rounded-full" data-id="element-130">
            <span className="text-[#d4a017] text-sm font-medium tracking-wide uppercase" data-id="element-131">
              Diversified Trading Solutions
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6" data-id="element-132">
            Connecting Markets,{' '}
            <span className="text-[#d4a017]" data-id="element-133">Driving Innovation</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl leading-relaxed" data-id="element-134">
            Manifold Trade facilitates wholesale trading across energy,
            automotive, and mobility sectors with expertise and reliability.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-135">
            <a href="#services" className="bg-[#d4a017] hover:bg-[#b88b14] text-white px-8 py-4 rounded-md font-semibold text-lg transition-all flex items-center justify-center gap-2 group" data-id="element-136">
              Our Services
              <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} data-id="element-137" />
            </a>
            <a href="#about" className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#1a4d5c] px-8 py-4 rounded-md font-semibold text-lg transition-all text-center" data-id="element-138">
              Learn More
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block" data-id="element-139">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2" data-id="element-140">
          <div className="w-1 h-2 bg-[#d4a017] rounded-full" data-id="element-141"></div>
        </div>
      </div>
    </section>;
}